import { TableCell } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import AppTableContentRow from "../../tables/appTableContentRow"

/** Loading skeleton for the LCT/TTR single device summary page attachment table */
const DeviceAttachmentLoadingRow = (): ReactElement => (
    <AppTableContentRow sx={{ height: 50 }}>
        <TableCell>
            <AppSkeleton width={300} />
        </TableCell>
        <TableCell>
            <AppSkeleton />
        </TableCell>
        <TableCell align="center">
            <AppSkeleton width={20} />
        </TableCell>
        <TableCell>
            <AppSkeleton width={100} />
        </TableCell>
    </AppTableContentRow>
)

export default DeviceAttachmentLoadingRow
